// admin.work-phases.$siteId.$workUnitId.$workPhaseId.tsx
// Route : /admin/work-phases/:siteId/:workUnitId/:workPhaseId
// Affiche le détail d'une phase de travail (admin).

import { createFileRoute, useNavigate } from "@tanstack/react-router";

import { getWorkPhases } from "@/infrastructure/api/work-phases.api";
import { Breadcrumb } from "@/presentation/components/shared/Breadcrumb";
import { WorkPhaseDetailPage } from "@/presentation/pages/WorkPhaseDetailPage";
import { LoadingSpinner } from "@/shared/components/LoadingSpinner";

export const Route = createFileRoute(
  "/admin/work-phases/$siteId/$workUnitId/$workPhaseId",
)({
  loader: async ({ params }) => {
    const phases = await getWorkPhases(params.workUnitId);
    const phase = phases.find((p) => p.id === params.workPhaseId);
    if (!phase) throw new Error("Phase introuvable");
    return phase;
  },
  pendingComponent: () => (
    <div className="flex h-64 items-center justify-center">
      <LoadingSpinner label="Chargement de la phase…" />
    </div>
  ),
  component: function AdminWorkPhaseDetailRouteComponent() {
    const { siteId, workUnitId } = Route.useParams();
    const workPhase = Route.useLoaderData();
    const navigate = useNavigate();

    return (
      <div className="space-y-4">
        <Breadcrumb
          items={[
            { label: "Accueil", to: "/dashboard" },
            { label: "Administration", to: "/admin" },
            { label: "Unités de travail", to: "/admin/work-units" },
            { label: workPhase.name },
          ]}
        />
        <WorkPhaseDetailPage
          siteId={siteId}
          workUnitId={workUnitId}
          workPhase={workPhase}
          onBack={() => navigate({ to: "/admin/sites" }).catch(() => undefined)}
        />
      </div>
    );
  },
});
